import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Tooltip, Avatar, Box } from "@mui/material";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { logout } from "../services/authService";
import { motion } from "framer-motion";

// ---------- COLORS ----------
const COLORS = {
    gradientAppBar: "linear-gradient(90deg, #5c5a5a 10%, #4ab7bd 40%, #2b2b2b 70%)",
    shadow: "0 2px 18px 0px rgba(50,220,199,0.13)",
    brandText: "#fff",
    iconBg: "#1ab98a",
    logoutIcon: "#38f9d7",
    logoutHover: "#fff",
    appBarHeight: 64,
};

const FancyAppBar: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    return (
        <motion.div
            initial={{ y: 0, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            style={{ position: "relative", zIndex: 1300 }}
        >
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    background: COLORS.gradientAppBar,
                    boxShadow: COLORS.shadow,
                    height: COLORS.appBarHeight,
                    zIndex: 1300,
                }}
            >
                <Toolbar sx={{ minHeight: COLORS.appBarHeight, position: "relative" }}>
                    <Avatar
                        sx={{
                            bgcolor: COLORS.iconBg,
                            width: 42,
                            height: 42,
                            boxShadow: COLORS.shadow,
                            position: "absolute",
                            left: 18,
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    >
                        <DirectionsCarFilledIcon sx={{ fontSize: 25, color: COLORS.brandText }} />
                    </Avatar>
                    <Box sx={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "100%",
                        textAlign: "center",
                        pointerEvents: "none"
                    }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 800,
                                color: COLORS.brandText,
                                letterSpacing: 1,
                                fontSize: { xs: 18, md: 22 }
                            }}
                        >
                            SwiftaGo Admin
                        </Typography>
                    </Box>
                    <Box sx={{
                        position: "absolute",
                        right: 18,
                        top: "50%",
                        transform: "translateY(-50%)",
                    }}>
                        <Tooltip title="Logout">
                            <IconButton
                                sx={{
                                    bgcolor: COLORS.logoutIcon,
                                    color: COLORS.logoutHover,
                                    transition: "0.2s",
                                    "&:hover": {
                                        bgcolor: COLORS.brandText,
                                        color: COLORS.logoutIcon,
                                    },
                                }}
                                onClick={handleLogout}
                            >
                                <LogoutIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Toolbar>
            </AppBar>
        </motion.div>
    );
};

export default FancyAppBar;
export const APP_BAR_HEIGHT = COLORS.appBarHeight;
